import { STATUS_TRANSLATION_MAP } from './DataErasureCard.constants'
import type { DeviceReportStatus } from './DataErasureCard.types'

export const getStatusTranslationKey = (status?: string) => {
  return status && status in STATUS_TRANSLATION_MAP
    ? STATUS_TRANSLATION_MAP[status as DeviceReportStatus]
    : null
}
